import React from "react";

import { DropdownFilterHeader, DropdownFilterCell } from "./";
import "./dropdownFilterDrawerStyles.css";

const DropdownFilterDrawer = ({
  name,
  allOptions = [],
  selectedOptions = [],
  setSelectedOptions = () => { },
  setVisibility = () => { },
  handleOnCheck = () => { }
}) => {
  const determinedChecked = id => ((selectedOptions.length !== 0) ? selectedOptions?.map(option => option?.id)?.includes(id) : false);

  return (
    <>
      <DropdownFilterHeader name={name} setVisibility={setVisibility} />
      {
        allOptions?.map((option, idx) => <DropdownFilterCell
          key={idx}
          id={option?.id}
          name={option?.name}
          option={option}
          selectedOptions={selectedOptions}
          setSelectedOptions={setSelectedOptions}
          checked={determinedChecked(option?.id)}
          handleOnCheck={handleOnCheck}
        />)
      }
    </>
  );
};

export default DropdownFilterDrawer;
